/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Aria_Site_FooterInputs */

const en_footer_aria_site_footer = /** @type {(inputs: Footer_Aria_Site_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site footer`)
};

const es_footer_aria_site_footer = /** @type {(inputs: Footer_Aria_Site_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pie de página del sitio`)
};

/**
* | output |
* | --- |
* | "Site footer" |
*
* @param {Footer_Aria_Site_FooterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_aria_site_footer = /** @type {((inputs?: Footer_Aria_Site_FooterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Aria_Site_FooterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_aria_site_footer(inputs)
	return en_footer_aria_site_footer(inputs)
});